import classNames from 'classnames/bind';
import React, { useEffect, useRef, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import Checkbox from '@/components/ui/kit/Checkbox';
import { FieldNumber } from '@/components/ui/kit/Field';
import Select from '@/components/ui/kit/Select';
import { roundToDecimal } from '@/utils/Formatter';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const [type, setType] = useState();
  const domRefs = useRef({
    speed: useRef(),
    throttle: useRef(),
  }).current;

  const hasThrottle = useMemo(() => {
    return command.data.throttle !== undefined;
  }, [command.data.throttle]);

  useEffect(() => {
    setType(command.data.type);
    domRefs.speed.current.value = command.data.speed.toFixed(1);
    domRefs.throttle.current.value = command.data.throttle?.toFixed(1) ?? '';
  }, [command.data]);

  const handleBlur = (e) => {
    const name = e.target.name;
    const value = Number(e.target.value);

    // Type 변경된 경우
    if (name === 'type') {
      dispatch(actions.mission.updateCommand(index, name, value));
    }
    // Speed 변경된 경우
    else if (name === 'speed') {
      const nextValue = roundToDecimal(value);
      dispatch(actions.mission.updateCommand(index, name, nextValue));
    }
    // Throttle 변경된 경우
    else if (name === 'throttle') {
      const nextValue = roundToDecimal(value);
      dispatch(actions.mission.updateCommand(index, name, nextValue));
    }
  };

  const toggleHasThrottle = () => {
    const nextValue = hasThrottle ? undefined : 0;
    dispatch(actions.mission.updateCommand(index, 'throttle', nextValue));
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Type">
        <Select name="type" value={type} onChange={handleBlur} className={cx('select')}>
          <option value={0}>Airspeed</option>
          <option value={1}>Ground Speed</option>
          <option value={2}>Ascend Speed</option>
          <option value={3}>Descend Speed</option>
        </Select>
      </FieldRow>
      <FieldRow label="Speed" unit="m/s">
        <FieldNumber ref={domRefs.speed} name="speed" onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Throttle" unit="%">
        <Checkbox checked={hasThrottle} onClick={toggleHasThrottle} />
        <FieldNumber ref={domRefs.throttle} name="throttle" disabled={!hasThrottle} onBlur={handleBlur} />
      </FieldRow>
    </div>
  );
};

export default Command;
